module.exports = __webpack_public_path__ + "img/alcatuire-inaurita-1771-pagina-de-titlu-big.6424f169.jpg";